import { render, staticRenderFns } from "./AdminClientRequests.vue?vue&type=template&id=1471b42c"
import script from "./AdminClientRequests.vue?vue&type=script&lang=js"
export * from "./AdminClientRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports